export enum PermissionsEnum {
	manageRolesAndPermissions = 1,
	manageGlobalReturns = 2,
	manageClients = 3,
	manageRollForward = 4,
	manageEntitiesEntityReturns = 5,
	manageDataIngestionTemplates = 6,
	importNewClientData = 7,
	confirmPaymentsReview = 8,
	submitPayments = 9,
	lockFinalizePeriodDataForEntity = 10,
	confirmReturnPreparation = 11,
	confirmReturnReview = 12,
	confirmSignerReview = 13,
	createReviewNote = 14,
	deleteReviewNote = 15,
	confirmClientApproval = 16,
	confirmEFiling = 17,
	confirmPaymentInfoReview = 18,
	unlockWorksheet = 19,
}
